import Dossier from '@/dossier/models/Dossier';
import DossierDetailContext from '@/dossier/models/DossierDetailContext';
import DossierContactTarget from '@/shared/models/DossierContactTarget';
import { mergeInto, removeById } from '@/shared/utils';
import { present } from '@/shared/utils/typescript';
import SurveyClient, { SurveyFeedbackData, SurveySearchResult } from '../client/SurveyClient';
import Survey from '../models/Survey';

class SurveyService {
  async loadAll(dossier: Dossier): Promise<Array<Survey>> {
    if (dossier.hasSurveys) {
      return SurveyClient.loadByDossier(dossier.id);
    } else {
      return [];
    }
  }

  async create(targets: Array<DossierContactTarget>, context: DossierDetailContext): Promise<void> {
    const survey = await SurveyClient.create(context.dossier.id, targets);
    mergeInto(survey, context.surveys);
  }

  async finalize(survey: Survey, searchResult: SurveySearchResult): Promise<void> {
    const id = present(survey.id);
    await SurveyClient.finalize(id, survey.dossier.id);
    removeById(searchResult.answeredSurveys, id);
  }

  async submitFeedback(survey: Survey, data: SurveyFeedbackData, context: DossierDetailContext): Promise<void> {
    const updatedSurvey = await SurveyClient.submitFeedback(survey, data);
    mergeInto(updatedSurvey, context.surveys);
  }
}

export default new SurveyService();